import { Controller } from '@hotwired/stimulus'
import { targetUpdate } from './components/component_controller'

interface StimulusEvent<T> extends Event {
  detail: {
    value: T
  }
}

export class LocationFormController extends Controller {
  static targets = ['organizationDependentSelect']

  declare readonly organizationDependentSelectTargets: HTMLElement[]

  updateOrganization(event: StimulusEvent<string>) {
    const organization = event.detail.value
    const disabled = organization === ''
    this.organizationDependentSelectTargets.forEach((target) => {
      targetUpdate(target, { disabled })
    })
  }
}
